export default "__VITE_ASSET__CjekTJL1__"